import React from 'react';

import UnderConstructionPage from './UnderConstructionPage';

const AboutPage: React.FC = () => <UnderConstructionPage />;

export default AboutPage;
